import { render, staticRenderFns } from "./rightModel.vue?vue&type=template&id=444aaa89&scoped=true&"
import script from "./rightModel.vue?vue&type=script&lang=js&"
export * from "./rightModel.vue?vue&type=script&lang=js&"
import style0 from "./rightModel.vue?vue&type=style&index=0&id=444aaa89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444aaa89",
  null
  
)

export default component.exports